<template>
  <div>
    <div class="xes-1v1-select-stu">
      <ul v-if="stuList.length">

        <li v-for="(item, index) in stuList" :key="index">
          <div class="xes-1v1-select-stu-item" :class="{ 'xes-1v1-select-stu-item-active': select_index === index }"
            @click="selectCurr(index)">
            <img class="xes-1v1-select-stu-item-icon" :src="getAvatar(index)" alt="" />
            <div class="xes-1v1-select-stu-item-info">
              <span class="xes-1v1-select-stu-item-name">{{ item.real_name }}</span>
              <div class="xes-1v1-select-stu-item-city">
                <span class="xes-1v1-select-stu-item-info-location" :style="{ color: getLocationColor(item) }">{{
                  item.city_code ? item.city_code_name : "城市未选择"
                }}</span>
              <span class="xes-1v1-select-stu-item-info-divider" > | </span>
                <span class="xes-1v1-select-stu-item-info-grade" :style="{ color: getGradeColor(item) }">{{ item.grade !== 0 ? item.grade_name : "年级未选择" }}</span>
              </div>
            </div>

            <img v-show="select_index === index" class="xes-1v1-select-stu-item-select-img"
              src="../../assets/img/login/invoice_item_icon_select.png" alt="" />

            <img v-show="item.isAuth" class="xes-1v1-select-stu-item-select-alAuth"
              src="../../assets/img/login/alauth.png" alt="" />
          </div>
        </li>
      </ul>

    </div>

    <div class="xes-1v1-select-stu-bottom-div">
      <button class="xes-1v1-select-stu-bottom-div-ok"
        :class="{ 'xes-1v1-select-stu-bottom-div-ok-active': this.select_index !== -1 }" @click="goAuth">
        授权该账户
      </button>
    </div>

    <div id="loadingToast" class="loading_toast" v-show="loading">
      <div class="loading_mask_transparent"></div>
      <div class="gif-loading"></div>
    </div>
  </div>
</template>

<script>

import { Toast } from "vant";
import getAccessToken from "@/utils/getToken";

export default {
  data() {
    return {
      // stuList: this.$route.query.familyList,
      stuList: JSON.parse(localStorage.getItem("talFamily")),
      select_index: -1,
      loading: false
    }
  },

  created() {
    // let temp = JSON.stringify(this.stuList)
    this.loading = true
    let uidList = []
    for (const tempKey in this.stuList) {
      uidList.push(this.stuList[tempKey].uid.toString())
    }
    let params = {
      uids: uidList
    }
    this.$api.clueTeacherForm.checkAuth(params).then((res) => {
      this.loading = false
      if (res.error_code === 0 && res.result) {
        for (const tempIndex in this.stuList) {
          this.stuList[tempIndex].authorizeType = 0
          let tempUid = this.stuList[tempIndex].uid.toString()
          let user = res.result.data[tempUid]
          if (res.result.data[tempUid] && user.authorizeType !==1) {
            this.stuList[tempIndex].isAuth = true
          } else {
            this.stuList[tempIndex].isAuth = false
          }
          if(user && user.authorizeType !== "undefined"){
            this.stuList[tempIndex].authorizeType = user.authorizeType
          }
        }
      }
    })

    getAccessToken().then(async (token) => {
      this.channel = (token && token !== "undefined") ? "app" : "企微"
      console.log("lsj", "channel=" + this.channel + ";;;;token = " + JSON.stringify(token))
    })

  },

  methods: {
    goBack() {
      this.$router.back()
    },
    goAuth() {
      if (this.select_index !== -1) {
        let tempUid = this.stuList[this.select_index].uid;
        let userName = this.stuList[this.select_index].real_name;
        if (this.stuList[this.select_index].isAuth) {
          return
        }
        console.log("lsj", "channel=" + this.channel)
        this.loading = true
        let tempCityCode = this.stuList[this.select_index].city_code
        if (this.stuList[this.select_index].grade
          && this.stuList[this.select_index].grade !== 0
          && this.stuList[this.select_index].city_code) {
          //静默注册，"authorizeType": 1 需要修正
          if(this.stuList[this.select_index].authorizeType == 1){
            let params = {
              channel: this.channel,
              uid: parseInt(tempUid)
            }
            this.$api.clueTeacherForm.authChannelAemd(params).then((res) => {
              this.loading = false
              if (res.error_code === 0 && res.result) {
                this.$router.push({
                  path: "/auth/authResult",
                  query: {
                    succFlag: res.result.status,
                    tips: res.result.message,
                    userName: userName,
                    code: res.result.code
                  }
                });
              } else {
                Toast(res.message)
              }
            }) 
            return;
          }
          let params = {
            action: 2, // 1 拒绝
            channel: this.channel,
            grade_id: parseInt(this.stuList[this.select_index].grade), // 10 11 12
            city_code: tempCityCode.toString(),
            uid: parseInt(tempUid)
          }
          this.$api.clueTeacherForm.authSubmit(params).then((res) => {
            this.loading = false
            if (res.error_code === 0 && res.result) {
              this.$router.push({
                path: "/auth/authResult",
                query: {
                  succFlag: res.result.status,
                  tips: res.result.message,
                  userName: userName,
                  code:res.result.code
                }
              });
            } else {
              Toast(res.message)
            }

          })
        } else {
          Toast("学员信息不完善")
        }
      }
    },

    selectCurr(index) {

      if (this.stuList[index].grade
        && this.stuList[index].grade !== 0
        && this.stuList[index].city_code
        && !this.stuList[index].isAuth) {
        this.select_index = index;
      }
    },
    getAvatar(index) {
      let userAvatar = this.stuList[index].avatar_url
      if (!userAvatar) {
        let sex = this.stuList[index].sex
        userAvatar = sex === 1 ?require('@/assets/img/login/mine_icon_header_boy.png') : require('@/assets/img/login/mine_icon_header_girl.png')
      }
      return userAvatar
    },
    getLocationColor(item) {
      return item.city_code ? 'rgba(33, 40, 50, 0.80)' : '#E02727'
    },

    getGradeColor(item) {
      return item.grade !== 0 ? 'rgba(33, 40, 50, 0.80)' : '#E02727'
    }

  }
}
</script>

<style lang="scss" scoped>
.xes-1v1-select-stu {
  margin: 0 16px 0 16px;
  padding-bottom: 110px;

  .xes-1v1-select-stu-item {
    position: relative;
    margin-top: 16px;
    display: flex;
    height: 111px;
    padding-left: 20px;
    background: url("../../assets/img/login/auth_select_stu_dis.png") no-repeat;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background-size: 100% 100%;

    // &-active {
    //   background: url("../../assets/img/login/auth_select_stu.png") no-repeat;
    //   background-size: 100% 100%;
    // }

    &-icon {
      border-radius: 50%;
      width: 62px;
      height: 62px;
    }

    &-info {
      margin-left: 22px;

      .xes-1v1-select-stu-item-name {
        color: #000C1D;
        font-family: PingFang SC;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        height:28px ;
        line-height: 28px;
      }

      .xes-1v1-select-stu-item-city {
        display: flex;
        align-items: flex-start;
        padding-top: 10px;
        .xes-1v1-select-stu-item-info-location,
        .xes-1v1-select-stu-item-info-divider, 
        .xes-1v1-select-stu-item-info-grade {
          color: rgba(33, 40, 50, 0.80);
          font-size: 14px;
          line-height: 18px;
        }
        .xes-1v1-select-stu-item-info-divider {
          color:rgba(33, 40, 50, 0.80);
          margin-left: 5px;
          margin-right: 5px;
        }
      }
    }

    &-location-img {
      width: 15px;
      height: 15px;
    }

    &-select-img {
      position: absolute;
      margin-top: 2px;
      right: 0;
      top: 0;
      width: 20px;
      height: 20px;
    }

    &-select-alAuth {
      position: absolute;
      right: 0;
      top: 0;
      width: 54px;
      height: 24px;
    }
  }

}

.xes-1v1-select-stu-bottom-div {

  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  height: 93px;
  border-top: 1px solid #f0f0f0;
  position: fixed;
  padding: 0px 20px 21px 20px;
  bottom: 0;
  width: 100%;
  z-index: 999;

  .xes-1v1-select-stu-bottom-div-ok {
    font-size: 16px;
    border-radius: 24px;
    color: white;
    height: 44px;
    width: 100%;
    background-color: #E7E8EA;
  }

  .xes-1v1-select-stu-bottom-div-ok-active {
    background-color: red;
    color: white;
  }
}
</style>